import React from 'react';

import { AddToCalendarIcon } from 'features/order-tracker/shared-components/svg';

import { ADD_TO_CALENDAR_LABEL, CALENDAR_FILENAME } from './constants';

import styles from './styles.module.scss';

export const ReminderInfo: React.FC<components.ReminderInfo> = ({ reminderUrl, title }) => {
  const analytics = `${title} - ${ADD_TO_CALENDAR_LABEL}`;

  return (
    <a
      href={reminderUrl}
      download={CALENDAR_FILENAME}
      className={styles.addReminderLink}
      data-analytics-link={analytics}
    >
      <AddToCalendarIcon />
      {ADD_TO_CALENDAR_LABEL}
    </a>
  );
};
